import { Controller } from 'stimulus';
import toArray from '../helpers/toArray';

class ActivityController extends Controller {
  connect() {
    this.toggleRequired();
  }

  resetPortaErrors() {
    const errorElements = toArray(this.element.querySelectorAll('.porta-error'));
    const errorMessages = toArray(this.element.querySelectorAll('.porta-error-message'));

    errorElements.forEach((element) => element.classList.remove('porta-error'));
    errorMessages.forEach((message) => message.remove());
  }

  toggleRequired() {
    this.resetPortaErrors();

    const checkedOptions = this.optionTargets.filter((option) => option.checked);

    this.optionTargets.forEach((option) => {
      option[checkedOptions.length ? 'removeAttribute' : 'setAttribute']('required', true);
    });
  }
}

ActivityController.targets = [
  'option',
];

export default ActivityController;
